import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListMatchListPayload } from '@app-store/slices/matchLists/list'

interface TaskAction extends Action {
    payload: IListMatchListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.matchLists.list

function* listMatchListSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/companies/match-lists`, {
            params
        })

        if (response.success) {
            yield put(onSuccess({ noSaveInStore: payload.noSaveInStore, ...response.result }))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listMatchListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listMatchListSagaTask)
}

export default listMatchListSaga
